"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderNavContent = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _hooks = require("material-ui-popup-state/hooks");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _NavCallout = require("./items/NavCallout");
var _FaNavItems = require("./items/FaNavItems");
var _ProductNavItems = require("./items/ProductNavItems");
var _NavCtaCallout = require("./items/NavCtaCallout");
var _ProductNavContent = require("./ProductNavContent");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const useStyles = (0, _styles.makeStyles)(theme => ({
  header: {
    fontWeight: 600,
    color: '#595959',
    marginBottom: '.2rem'
  },
  buttonGroup: {
    borderRadius: '8px',
    padding: '.4rem',
    background: '#E5EAF4',
    boxShadow: 'inset 0 0 10px rgb(158, 161, 166, .2)'
  },
  activeButton: {
    padding: '0 60px',
    borderRadius: '8px!important',
    border: '1px solid rgba(0, 0, 0, 0)',
    textTransform: 'unset!important',
    fontSize: '1rem',
    boxShadow: 'none',
    color: theme.white,
    background: theme.workwaveBlue,
    '&:hover': {
      backgroundColor: theme.workwaveBlue
    }
  },
  inactiveButton: {
    padding: '0 60px',
    borderRadius: '8px!important',
    border: '1px solid rgba(0, 0, 0, 0)',
    textTransform: 'unset!important',
    fontSize: '1rem',
    boxShadow: 'none',
    color: '#9EA1A6',
    background: '#E5EAF4',
    '&:hover': {
      color: '#595959',
      backgroundColor: '#E5EAF4'
    }
  }
}));
const Section = _ref => {
  let {
    header,
    content,
    close
  } = _ref;
  const classes = useStyles();
  const [chunked, setChunked] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setChunked((0, _lodash.chunk)(content, 4));
  }, [content]);
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    xs: chunked.length * 3
  }, header && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: classes.header
  }, header)), chunked.map((chunk, index) => /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: true,
    key: index,
    spacing: 1,
    justifyContent: "flex-start",
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_FaNavItems.FaNavItems, {
    items: chunk,
    noHeaderWidth: null,
    close: close
  }))));
};
const HeaderNavContent = _ref2 => {
  let {
    links,
    calloutIcon,
    calloutTitle,
    calloutContent,
    close,
    calloutCtas = [],
    header,
    resourceBar,
    children
  } = _ref2;
  const [productToggleView, setProductToggleView] = (0, _react.useState)('Field Service Software');
  const classes = useStyles();
  const childrenWithClose = _react.default.Children.map(children, child => /*#__PURE__*/_react.default.cloneElement(child, {
    close
  }));
  const handleToggle = (e, category) => {
    e.preventDefault();
    setProductToggleView(category);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header === 'products' ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justifyContent: "center",
    style: {
      paddingBottom: '2rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.ButtonGroup, {
    className: classes.buttonGroup
  }, Object.keys(links).map((link, index) => /*#__PURE__*/_react.default.createElement(_core.Button, {
    key: index,
    className: productToggleView === link ? classes.activeButton : classes.inactiveButton // disableRipple
    ,

    onClick: e => handleToggle(e, link),
    style: {
      marginRight: index === 0 && '1px'
    },
    value: link,
    id: "nav-products-".concat(link.toLowerCase().replace(' ', '-'))
  }, link)))) : null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    spacing: 2
  }, header === 'products' ? Object.keys(links).filter(link => link === productToggleView).map((link, index) => /*#__PURE__*/_react.default.createElement(_ProductNavContent.ProductNavContent, {
    header: link,
    content: links[link],
    close: close,
    key: index
  })) : Object.keys(links).map((link, index) => /*#__PURE__*/_react.default.createElement(Section, {
    header: link,
    content: links[link],
    close: close,
    key: index
  })), calloutContent ? /*#__PURE__*/_react.default.createElement(_NavCallout.NavCallout, {
    calloutIcon: calloutIcon,
    calloutTitle: calloutTitle,
    calloutContent: calloutContent,
    resourceBar: resourceBar
  }) : calloutCtas.length ? /*#__PURE__*/_react.default.createElement(_NavCtaCallout.NavCtaCallout, {
    calloutCtas: calloutCtas,
    resourceBar: resourceBar
  }, childrenWithClose) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '1rem'
    }
  })));
};
exports.HeaderNavContent = HeaderNavContent;